import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { UserSelect } from '../../../../../../../api';
import { ElciaButton } from '../../../../../../components/buttons/button/button';
import { Loader } from '../../../../../../components/loader/loader';

@Component({
  selector: 'elcia-user-grid',
  imports: [TableModule, TranslatePipe, ElciaButton, Loader],
  templateUrl: './user-grid.html',
})
export class UserGrid {
  users = input<UserSelect[]>([]);
  isLoading = input<boolean>(false);
  currentUserId = input<number | null>(null);
  onDelete = output<UserSelect>();

  protected delete(row: UserSelect): void {
    this.onDelete.emit(row);
  }
}
